import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SearchService } from '../../search.service';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../core/navigation.service';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { ADD_SEARCH, DELETE_SEARCH, UserPreferenceEvent } from '../../../models/user-favourite-event';
import { SavedSearchService } from '../../saved-search.service';
import { SavedSearchConfig } from './../../models/saved-search-config';

@Component({
  selector: 'lfwms-manage-saved-search',
  templateUrl: './manage-saved-search.component.html',
  styleUrls: ['./manage-saved-search.component.css']
})
export class ManageSavedSearchComponent implements OnInit, OnDestroy {

  @Input() public searchService: SearchService;
  public savedSearchConfig: SavedSearchConfig;
  public searchList = [];
  public searchListOrig = [];
  public showHide;

  constructor(protected alertService: AlertService,
      protected savedSearchService: SavedSearchService,
      protected resourceService: ResourceService,
      protected navService: NavigationService,
      protected userPreferenceService: UserPreferenceService) {
    this.userPreferenceService.receiveEvent()
      .subscribe((event: any) => {
        if (event.source === 'saved_search') {
          // if this event originated from the left menu, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_SEARCH) {
          this.savedSearchConfig.searchName = '';
          // LFWM-1767 : Code fix
          this.savedSearchConfig.searchId = null;
        }
      });
  }

  public ngOnInit() {
    this.savedSearchConfig = this.searchService.getSavedSearchConfig();
  }

  public ngOnDestroy() {
    this.searchService.clearSavedSearchConfig();
  }

  private notifyEvent(type: number, item: string) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.item = item;
    event.source = 'saved_search';
    this.userPreferenceService.notifyEvent(event);
  }

  // to save new search criteria and update the name of an existing criteria
  public saveSearchCriteria(savedSearchConfig: SavedSearchConfig, updateNameFlag: boolean) {
    try {
      // the method is addded to validate the length of input search criteria of save search and load search
      // first it checks for saving without name search criteria condition
      if (!savedSearchConfig.searchName) {
        this.alertService.clearAll().error(this.resourceService.get('msg_entr_srch_crit'));
        return false;
        // Second it checks for saving with name exceed limit of 100 words
      } else if (savedSearchConfig.searchName.length > 100) {
        this.alertService.clearAll().error(this.resourceService.get('lbl_maxlngthSavSrch'));
        return false;
      } else {
        this.validateSearchCriteria();
      }
    } catch (error) {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error.message));
      return false;
    }
    const searchcriteriaName = savedSearchConfig.searchName;
    let searchId = savedSearchConfig.searchId;
    if (updateNameFlag === false) {
      if (searchcriteriaName !== savedSearchConfig.searchNameOrig) {
        searchId = null;
      }
    }
    if (searchcriteriaName) {
      this.savedSearchService
        .saveSearchCriteria(searchcriteriaName, searchId,
          this.searchService.searchParams.tableId, this.searchService)
        .subscribe((resp: any) => {
          if (resp['statusCode'] && resp['statusMessage']) {
            if (resp['statusCode'] === 200) {
              // update searchid so as to do update if you click save second time for a newly created search;
              savedSearchConfig.searchId = resp.searchId;
              savedSearchConfig.searchNameOrig = savedSearchConfig.searchName;
              this.alertService.clearAll().success(this.resourceService.translateServerResponse(resp.statusMessage));
              this.savedSearchConfig.searchName = '';
              this.navService.preventNavigation = false;
              this.notifyEvent(ADD_SEARCH, searchId + '');
            }
          } else {
            if (resp.error) {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(resp.error));
            }
          }
        }, (error: any) => {
          this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
        });
    } else {
      this.alertService.clearAll().error(this.resourceService.get('msg_entr_srch_crit'));
    }
  }

  // method used to validate the search criteria
  public validateSearchCriteria() {
    const searchCriteria = this.searchService.getSearchCriteria();
    searchCriteria.conditions.forEach((condition: any) => {
      const filteredClauses = condition.clauses
        .filter((clause: any) => {
          if (clause.value === undefined || clause.value === null) {
            return false;
          } else if (typeof (clause.value) === 'boolean') {
            return true;
          } else if (clause.value === '') {
            return false;
          } else {
            return true;
          }
        });
      if (filteredClauses.length === 0) {
        this.alertService.clearAll().error(this.resourceService.get('lbl_inclClmnCondn'));
      } else {
        return false;
      }
    });
  }

  // to open an existing search criteria
  public openSearchCondition(savedSearchConfig: any) {
    let isValidCondition: boolean = true;
    this.searchService.setNonMandatoryConditionsCount(0);
    this.savedSearchService.loadSearchCriteria(savedSearchConfig.searchId, this.searchService.getSavedSearchConfig())
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            const formattedCriteria = this.savedSearchService
              .transformSearchCriteriaToModel(resp, this.searchService);
            if (!formattedCriteria) {
              this.alertService.clearAll().error(this.resourceService.get('msg_invalid_criteria'));
              return;
            }
            this.searchService.searchCriteria.conditions.forEach((condition: any) => {
              // JIRA LFWM-1685 - user is not allowed to edit the uneditable default search condition
              if (condition.isReadOnly) {
                condition.clauses.forEach((clause: any) => {
                  const formattedClauses = formattedCriteria['conditions'][0].clauses;
                  for (let index = 0; index < formattedClauses.length; index++) {
                    const formattedClause: any = formattedClauses[index];
                    if (clause.column === formattedClause.column && clause.value !== formattedClause.value) {
                      isValidCondition = false;
                      this.alertService.clearAll().error(this.resourceService.get('msg_invalid_criteria'));
                      this.showHide = true;
                    }
                  }
                });
              }
            });
            if (isValidCondition) {
              this.searchService.setSearchCriteria(formattedCriteria);
              this.searchService.getSearchCriteria().conditions
                .forEach((condition: any) => {
                  if (!condition.isMandatory) {
                    this.searchService.setNonMandatoryConditionsCount(
                      this.searchService.getNonMandatoryConditionsCount() + 1);
                  }
                });
            }
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll().error(this.resourceService
              .translateServerResponse(resp.error));
          }
        }
      }, (error: any) => {
        this.alertService.clearAll().error(error);
      });
    // save to this.savedSearchConfig if success
    savedSearchConfig.searchNameOrig = savedSearchConfig.searchName;
    this.savedSearchConfig = savedSearchConfig;
  }

  // delete search criteria in the load search table
  public deleteSearchCondition(searchId: number) {
    const searchIdArray = [];
    searchIdArray.push(searchId);
    this.savedSearchService.deleteSearchCriteria(searchIdArray)
      .subscribe((data: any) => {
        this.savedSearchList();
        if (this.savedSearchConfig.searchId === searchId) {
          /* clear already loaded(last created) search id if its same as deleted one.
          so as to allow saving new one with same name instantly
          without clearing the already loaded search */
          this.savedSearchConfig.searchId = null;
          // LFWM-3966, After delete, clear SearchName also in input field
          this.savedSearchConfig.searchName = '';
        }
        this.notifyEvent(DELETE_SEARCH, searchId + '');
      });
  }

  // Display all search criteria saved for a corresponding page
  public savedSearchList() {
    this.savedSearchService
      .getSavedSearchList(this.searchService.searchParams.tableId)
      .subscribe((resp: any) => {
        this.searchList = resp.searchResults;
        this.searchListOrig = resp.searchResults;
        if (this.searchList.length > 0) {
          this.showHide = true;
        }
      });
  }

  // method to filter searchname from search box
  public searchFromList(criteriaName: string) {
    this.searchList = [];
    this.searchListOrig.forEach((element: any) => {
      const name: string = element.searchName;
      if (name.toLowerCase().includes(criteriaName.toLowerCase())) {
        this.searchList.push(element);
      }
    });
    return this.searchList;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public preventNavigationWithoutSave() {
    this.navService.preventNavigation = true;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/filter/manage-saved-search/manage-saved-search.component.ts